import { render, staticRenderFns } from "./category.vue?vue&type=template&id=6323a4e9&"
import script from "./category.vue?vue&type=script&lang=js&"
export * from "./category.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/admin_admin-web_uLO7/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6323a4e9')) {
      api.createRecord('6323a4e9', component.options)
    } else {
      api.reload('6323a4e9', component.options)
    }
    module.hot.accept("./category.vue?vue&type=template&id=6323a4e9&", function () {
      api.rerender('6323a4e9', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/view/bianlidianManage/category/category.vue"
export default component.exports